import React, { useEffect } from 'react';
import Button from 'components/UI/Button';
import ResultModal from './ResultModal';
import { useTrans } from 'utils/localisation';
import { observer, pricingCalculator as store } from 'store';
import { useStateModal, useWindowResize } from 'utils/hooks';
import { pushCustomEvent } from 'utils/analytics';
import { getAdditionalFormData } from '../../utils.js';
import * as styles from './Footer.module.scss';

function Footer({
  id,
  analyticsEvent,
  steps,
  active,
  setActive,
  firstStep,
  lastStep,
  setTriggerValidation,
}) {
  const { width } = useWindowResize();
  const { modalState, showModal, hideModal } = useStateModal();
  const t = useTrans(['common', 'pricingCalculator']);
  const {
    currentStep,
    nextStep,
    prevStep,
    setPayload,
    getPayload,
    previouslyOpened,
    setPreviouslyOpened,
  } = store;
  const last = currentStep === lastStep;
  const payload = getPayload();
  const currentStepLabel = steps?.[currentStep - 2]?.label;
  const currentStepSelectedData = payload[currentStepLabel];

  const handleNext = () => {
    if (last) {
      if (analyticsEvent) {
        pushCustomEvent(analyticsEvent, {
          action: 'open-modal',
          label: id,
        });
      }
      showModal();
    } else {
      if (firstStep) {
        if (!active) {
          setTriggerValidation(true);
          return;
        }
        if (active !== previouslyOpened) {
          setPayload({});
        }
        setPreviouslyOpened(active);
      }
      nextStep();
    }
  };

  const resetFirstStep = () => setActive(null);

  useEffect(() => {
    if (width < 546) {
      hideModal();
    }
  }, [width]);

  return (
    <div className={styles.buttonsWrapper}>
      {firstStep && (
        <Button className={styles.appearAnimation} onClick={handleNext}>
          {t('next')}
        </Button>
      )}
      {!firstStep && (
        <>
          <Button className={styles.appearAnimation} onClick={prevStep} theme="secondary">
            {t('back')}
          </Button>
          <Button
            className={styles.appearAnimation}
            onClick={handleNext}
            disabled={!currentStepSelectedData}
          >
            {t('next')}
          </Button>
        </>
      )}
      <ResultModal
        isOpen={modalState.isOpen}
        closeModalCallback={hideModal}
        calculatorID={id}
        formName={id}
        getAdditionalFormData={() => getAdditionalFormData(steps, analyticsEvent)}
        resetFirstStep={resetFirstStep}
        analyticsEvent={analyticsEvent}
      />
    </div>
  );
}

export default observer(Footer);
